import { render, staticRenderFns } from "./_AdminDashboard.vue?vue&type=template&id=cc2e85f4&"
import script from "./_AdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./_AdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports